import { render, staticRenderFns } from "./privateAbnormal.vue?vue&type=template&id=baf23dd0&scoped=true"
import script from "./privateAbnormal.vue?vue&type=script&lang=js"
export * from "./privateAbnormal.vue?vue&type=script&lang=js"
import style0 from "./privateAbnormal.vue?vue&type=style&index=0&id=baf23dd0&prod&lang=scss&scoped=true"
import style1 from "./privateAbnormal.vue?vue&type=style&index=1&id=baf23dd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf23dd0",
  null
  
)

export default component.exports